import { Button } from "@mui/material";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { USER_ROLE } from "../config/constants";
import { GlobalContext } from "../helpers/contexts/contexts";

const NotFound404 = () => {
  const { loggedInUserRole } = useContext(GlobalContext);
  const redirectToDashboardPath =
    loggedInUserRole === USER_ROLE.PARENT_COMPANY.NAME ||
    loggedInUserRole === USER_ROLE.PARENT_COMPANY_USER.NAME ||
    loggedInUserRole === USER_ROLE.PARENT_COMPANY_SUB_USER.NAME
      ? "/overview-dashboard"
      : "/dashboard";

  return (
    <div className="not-found-404">
      <div className="card shadow">
        <div className="card-body d-flex-center flex-column">
          <img className="my-2" src={`/img/Group2146.svg`} alt="" />
          <h2 className="heading3">404 Not found</h2>
          <p className="heading12 px-md-5 text-center">
            The page you are looking for was not found!
          </p>
          <Button
            component={Link}
            to={`${redirectToDashboardPath}`}
            variant="contained"
            color="primary"
            className="my-4"
            size="large"
          >
            Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};
export default NotFound404;
